import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../context/AuthContext'

export default function Forbidden() {
  const { t } = useTranslation(['settings'])
  const { user } = useAuth()
  const roles = user?.roles || (user?.role ? [user.role] : [])

  let homeLabel = t('forbidden.goBack')
  let homeTo = '/'
  if (roles.includes('admin')) {
    homeLabel = t('forbidden.goDashboard'); homeTo = '/'
  } else if (roles.includes('pm_po') || roles.includes('engineer')) {
    homeLabel = t('forbidden.goDashboard'); homeTo = '/'
  } else if (roles.includes('purchaser')) {
    homeLabel = t('forbidden.goAcquisitions'); homeTo = '/purchases'
  } else if (roles.includes('commercial')) {
    homeLabel = t('forbidden.goCrm'); homeTo = '/crm'
  } else if (roles.includes('c_level')) {
    homeLabel = t('forbidden.goCLevel'); homeTo = '/c-level'
  }

  return (
    <div className="min-h-[80vh] flex flex-col items-center justify-center text-center p-8">
      <div className="mx-auto w-14 h-14 rounded-2xl bg-red-50 flex items-center justify-center mb-5">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#DC2626" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="11" width="18" height="11" rx="2" />
          <path d="M7 11V7a5 5 0 0 1 10 0v4" />
        </svg>
      </div>
      <h1 className="text-2xl font-semibold text-gray-900 mb-2">{t('forbidden.heading')}</h1>
      <p className="text-sm text-gray-500 max-w-md">
        {t('forbidden.body')}
      </p>
      <Link
        to={homeTo}
        className="mt-6 text-sm bg-gray-900 text-white px-4 py-2 rounded-lg hover:bg-gray-700 transition-colors"
      >
        {homeLabel}
      </Link>
    </div>
  )
}
